import * as React from 'react';
import { useContext } from 'react';
import { Box, Flex, Stack } from '../../../shared/layouts';
import { useQuery } from 'react-query';
import axios from 'axios';
import MessagebarContext from '../../../../context/MessagebarContext';
import { useTranslation } from 'react-i18next';
import PlaceholderCard from '../../../shared/PlaceholderCard';
import Card from '../../../shared/Card';
import Button from '../../../shared/Button';
import { Link, useNavigate } from 'react-router-dom';
import CalculationButton from '../../calculations/components/CalculationButton';
import useIconLibrary from "../../../../hooks/useIconLibrary";

const CalculationWidget = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { ForwardIcon } = useIconLibrary();
  const { setAlertMessage } = useContext(MessagebarContext);

  const { data: calculationsList = [] } = useQuery(
    'calculations',
    async () => {
      try {
        const { data } = await axios('/calculations');
        return data?.data;
      } catch (error) {
        setAlertMessage();
      }
    }
  );

  const latestCalc =
    calculationsList?.length > 0 &&
    calculationsList[calculationsList?.length - 1];

  return calculationsList?.length === 0 ? (
    <PlaceholderCard
      title={t('Wat kan ik maximaal lenen?')}
      actionText={t('Start berekening')}
      actionUrl={'/tools/max-mortgage'}
    />
  ) : (
    <>
      <Card>
        <Stack space={'m'}>
          <Box fontScale={'l'} fontWeight={'bold'}>
            {t('Wat kan ik maximaal lenen?')}
          </Box>
          <Box fontWeight={'bold'}>{t('Laatste eigen berekening')}</Box>
          <Flex
            flexDirection={{ mobile: 'column', desktop: 'row' }}
            alignItems={'center'}
            css={{ '> *': { flex: '1 0 40%' } }}
          >
            <CalculationButton
              name={latestCalc?.name}
              output={latestCalc?.output}
              onClick={() => navigate(`/tools/max-mortgage?calculationId=${latestCalc?.id}`)}
            />
            <Flex
              mt={{ mobile: 'xl', desktop: '0' }}
              ml={{ mobile: 0, desktop: 'm' }}
              justifyContent={'flex-end'}
              width={{ mobile: '100%', desktop: 'auto' }}
            >
              <Link to={`/tools/max-mortgage`}>
                <Button
                  variant={'anchor'}
                  css={{ padding: 0, textAlign: 'right', whiteSpace: 'nowrap' }}
                >
                  <Flex alignItems={'center'}>
                    {t('Maak nieuwe berekening')}
                    <ForwardIcon
                      width={'1.5rem'}
                      height={'1.5rem'}
                      css={({ colors, space }) => ({
                        marginLeft: space.s,
                        fill: colors?.secondary
                      })}
                    />
                  </Flex>
                </Button>
              </Link>
            </Flex>
          </Flex>
        </Stack>
      </Card>
    </>
  );
};

export default CalculationWidget;
